import { prepareArgs } from './utils';

const API_URL = 'https://diskuze.seznam.cz/graphql';
const API_TIMEOUT = 15000;
const API_QUERY = `
      query FetchCommentCount($entityIds: [ID!]!) {
        discussionSummary(canonicalString_in: $entityIds) {
          summary
        }
      }
    `;

function callApi(operationName, query, variables, config) {
	const request = new XMLHttpRequest();
	request.open('POST', config.apiUrl);
	request.timeout = API_TIMEOUT;
	request.setRequestHeader('Content-Type', 'application/json');

	return new Promise((resolve, reject) => {
		request.ontimeout = () => {
			reject(
				new Error(
					`The request to the API at ${API_URL} timed out after ${API_TIMEOUT} milliseconds`
				)
			);
		};
		request.onerror = () => {
			reject(
				new Error(`The request to the API at ${API_URL} failed with an error`)
			);
		};
		request.onabort = () => {
			reject(new Error(`The request to the API at ${API_URL} was aborted`));
		};
		request.onload = () => {
			if (request.status !== 200) {
				reject(
					new Error(
						`The API at ${API_URL} responded with HTTP status code ${request.status}. Response body:\n` +
							request.responseText
					)
				);
				return;
			}

			let deserializedResponse;
			try {
				deserializedResponse = JSON.parse(request.responseText);
			} catch (deserializationError) {
				reject(deserializationError);
				return;
			}
			if (
				!deserializedResponse ||
				(!('data' in deserializedResponse) && !('errors' in deserializedResponse))
			) {
				reject(
					new Error(
						`The API at ${API_URL} returned invalid response:\n${request.responseText}`
					)
				);
				return;
			}
			if (deserializedResponse.errors && deserializedResponse.errors.length) {
				const error = new Error(
					`The GraphQL API at ${API_URL} returned error(s)`
				);
				error.errors = deserializedResponse.errors;
				reject(error);
				return;
			}

			resolve(deserializedResponse.data);
		};

		request.send(
			JSON.stringify({
				operationName,
				query,
				variables
			})
		);
	});
}

/**
 *
 * @param args {(...string | string[], object)} entityIds or array of entityIds and config object
 * @returns {Promise<*>}
 */
export function discussionFetchCommentCount(...args) {
	const { entityIds, config } = prepareArgs(args);

	return callApi(
		'FetchCommentCount',
		API_QUERY,
		{
			entityIds
		},
		config
	).then(({ discussionSummary: { summary } }) => {
		return summary.reduce((summaryMap, discussion) => {
			summaryMap[discussion.discussionId] = {
				commentCount: discussion.count,
				status: discussion.status
			};
			return summaryMap;
		}, {});
	});
}
